import { render, staticRenderFns } from "./tabson.vue?vue&type=template&id=436f76e6"
import script from "./tabson.vue?vue&type=script&lang=js"
export * from "./tabson.vue?vue&type=script&lang=js"
import style0 from "./tabson.vue?vue&type=style&index=0&id=436f76e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports